import { yup } from '@comptia-sso/core';
import { TFunction } from 'react-i18next';

export const getValidationSchema = (t: TFunction): yup.SchemaOf<unknown> =>
  yup.object().shape({
    productId: yup.number().required(t('Validation.Required')),
  });
